



import Vue from 'vue';

export default Vue.extend({
  props: {
    isDirty: {
      type: Boolean,
      required: true,
    },
    saveFun: {
      type: Function,
      required: true,
    },
  },
  mounted() {
    this.$store.dispatch('globals/setFormSaveFun', this.saveFun);
  },
  beforeDestroy() {
    this.$store.dispatch('globals/setFormSaveFun', null);
    this.$store.dispatch('globals/setDirty', null);
  },
  watch: {
    isDirty: {
      handler(isDirty: boolean) {
        this.$store.dispatch('globals/setDirty', isDirty);
      },
      immediate: true,
    },
  },
});
